import React, { useState } from "react";
import {
  AddButton,
  BackButton,
  ThinTextField,
  ThinDropdown,
} from "../../common/GeneralComponent";
import { fetchData } from "../../../utils/functions";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const AddDistricts = () => {
  const [generatedCode, setGeneratedCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    District_Name: Yup.string()
      .min(3, "District name must be at least 3 characters")
      .max(50, "District name must not exceed 50 characters")
      .matches(
        /^[a-zA-Z\s]+$/,
        "District name can only contain letters and spaces"
      )
      .required("District name is required"),
    Status: Yup.string().required("Status is required"),
  });

  const formik = useFormik({
    initialValues: {
      District_Name: "",
      Status: 1,
    },
    validationSchema,
    onSubmit: async (values) => {

      const data = {
        District_Name: values.District_Name,
        Status: values.Status,
      };

      try {
        setIsSubmitting(true);
        await fetchData(
          "districts",
          "POST",
          data,
          {},
          {},
          navigate,
          "/districts",
          dispatch
        );
        toast.success("District added successfully");
        formik.resetForm();
        navigate("/districts");
      } catch (error) {
        console.error("Error creating district:", error);
        toast.error(error?.message || "Failed to create district");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const generateCodeFromName = (name) => {
    if (name && name.length >= 2) {
      return name.substring(0, 2).toUpperCase();
    }
    return "";
  };

  return (
    <div className="w-full my-4 mx-auto">
      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Create District
        </h1>
        <BackButton text="Back" to="/districts" />
      </div>

      <div className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4 mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create District
          </h1>
        </div>
        <form className="p-4" onSubmit={formik.handleSubmit}>
          <div className="grid lg:grid-cols-2 gap-5 grid-cols-1">
            <ThinTextField
              id="District_Name"
              label="District Name"
              placeholder="Karachi"
              type="text"
              name="District_Name"
              value={formik.values.District_Name}
              onChange={(e) => {
                formik.handleChange(e);
                const code = generateCodeFromName(e.target.value);
                setGeneratedCode(code);
              }}
              onBlur={formik.handleBlur}
              error={
                formik.touched.District_Name &&
                Boolean(formik.errors.District_Name)
              }
              helperText={
                formik.touched.District_Name && formik.errors.District_Name
              }
            />
            {/* <ThinTextField
              id="district_code"
              label="District Code"
              type="text"
              value={generatedCode}
              onChange={() => {}}
              onBlur={() => {}}
              disabled={true}
              error={false}
              helperText="Code is auto-generated"
            /> */}
            <ThinDropdown
              label="Status"
              id="Status-dropdown"
              name="Status"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
              ]}
              value={formik.values.Status}
              onChange={(e) => formik.setFieldValue("Status", e.target.value)}
              onBlur={() => formik.setFieldTouched("Status", true)}
              error={formik.touched.Status && formik.errors.Status}
              helperText={formik.touched.Status && formik.errors.Status}
            />
          </div>
          <div className="p-4">
            <AddButton type="Submit" text="Submit" isLoading={isSubmitting} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDistricts;
